import type { LucideIcon } from '@/shared/icon-library';
import {
  CircleUserIcon,
  DiamondIcon,
  FolderIcon,
  HashIcon,
  InboxIcon,
  KanbanIcon,
  LayersIcon,
  LinkIcon,
  ListTodoIcon,
  MessageSquareIcon,
  MessagesSquareIcon,
  TriangleIcon,
  UsersRoundIcon,
} from '@/shared/icon-library';

export type SharedObjectKind =
  | 'inbox'
  | 'task'
  | 'subtask'
  | 'project'
  | 'folder'
  | 'milestone'
  | 'channel'
  | 'thread'
  | 'message'
  | 'comment'
  | 'person'
  | 'people'
  | 'file'
  | 'checklist'
  | 'prism';

export const OBJECT_ICON: Record<SharedObjectKind, LucideIcon> = {
  inbox: InboxIcon,
  task: LayersIcon,
  subtask: LayersIcon,
  project: KanbanIcon,
  folder: FolderIcon,
  milestone: DiamondIcon,
  channel: HashIcon,
  thread: MessagesSquareIcon,
  message: MessageSquareIcon,
  comment: MessageSquareIcon,
  person: CircleUserIcon,
  people: UsersRoundIcon,
  file: LinkIcon,
  checklist: ListTodoIcon,
  prism: TriangleIcon,
};
